import { motion, AnimatePresence } from 'framer-motion';

interface HeroOverlayProps {
  visible: boolean;
}

export default function HeroOverlay({ visible }: HeroOverlayProps) {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6 }}
          className="fixed top-0 left-0 w-full h-full z-10 pointer-events-none
                     flex flex-col items-center justify-center"
        >
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-center px-6"
          >
            <div className="text-[11px] font-mono uppercase tracking-[0.3em] text-cyan-400/60 mb-4">
              Lehlogonolo Theledi // Mission Control
            </div>
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white mb-4 leading-tight">
              <span className="bg-gradient-to-r from-cyan-400 via-blue-400 to-purple-500 bg-clip-text text-transparent">
                DevOps
              </span>
              <br />
              <span className="text-white/90">Engineer</span>
            </h1>
            <p className="text-gray-500 text-sm max-w-md mx-auto leading-relaxed font-light">
              Kubernetes / GitOps / Cloud Infrastructure
            </p>

            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ delay: 1.2 }}
              className="mt-10 flex items-center gap-2 text-gray-600 text-xs font-mono"
            >
              <div className="w-1 h-1 rounded-full bg-cyan-400 animate-pulse" />
              Click a marker to explore
            </motion.div>
          </motion.div>

          {/* Corner decorations */}
          <div className="absolute top-6 left-6 text-[10px] font-mono text-gray-700">
            <div>SYS.ONLINE</div>
            <div className="text-cyan-500/40 mt-1">v1.0.0</div>
          </div>
          <div className="absolute top-6 right-6 text-[10px] font-mono text-gray-700 text-right">
            <div>LAT 0.00 / LON 0.00</div>
            <div className="text-cyan-500/40 mt-1">ORBIT.STABLE</div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
